// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BETypeElement } from './BETypeElement';
import { EnumAccessModifier } from '../../../../../com/MetaPattern/MDA/MD/Base/EnumAccessModifier';
import { BEComponent } from './BEComponent';
import { EnumItem } from './EnumItem';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { BEEnumExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/EntityModel/BEEnumExtend';
/**
 * 枚举 实体类
 * 枚举类型
 */
export class BEEnum extends BETypeElement {
  /** 访问修饰符 : 访问修饰符 */
  private _accessModifier: EnumAccessModifier;

  /** 设置：访问修饰符 */
  public get accessModifier() {
    return this._accessModifier;
  }

  /** 获取：访问修饰符 */
  public set accessModifier(value: EnumAccessModifier) {
    this._accessModifier = value;
  }

  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: BEComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: BEComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 枚举项 */
  private _enumItems: Array<EnumItem>;

  /** 获取：枚举项 */
  public get enumItems() {
    return this._enumItems;
  }

  /** 设置：枚举项 */
  public set enumItems(value: Array<EnumItem>) {
    this._enumItems = value;
  }

  constructor() {
    super();
    BEEnumExtend.Init(this);
    this._accessModifier = EnumAccessModifier.Public;
    this._component_ID = '';
    this._component = null;
    this._enumItems = new Array<EnumItem>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BEEnum, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.accessModifier = element.accessModifier;
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.accessModifier = json.AccessModifier as EnumAccessModifier;
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = BEComponent.Create(json.Component);
    // }
    if (json.EnumItems && json.EnumItems.length > 0) {
      json.EnumItems.forEach((element: any) => {
        const enumItem = EnumItem.Create(element);
        // enumItem.enum = this;
        this.enumItems.push(enumItem);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.AccessModifier = this.accessModifier;
    json.Component_ID = this.component_ID;
    if (this.enumItems && this.enumItems.length > 0) {
      json.EnumItems = [];
      this.enumItems.forEach((element) => {
        json.EnumItems.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('代码属性', 'accessModifier', '访问修饰符', EnumDataType.Reference, this.accessModifier, true, '访问修饰符', 'EnumAccessModifier', 'PGRowEnumValue');
    return context;
  }

  static Create(json: any): BEEnum {
    const bEEnum = new BEEnum();
    bEEnum.Deserialize(json);
    bEEnum.json = json;
    return bEEnum;
  }
}
